import React from 'react';
import PropTypes from 'prop-types';
import BabyCreateContainer from '../containers/BabyCreateContainer';
import Modal from './Modal';
import { connect } from 'react-redux';
import { getBabiesSortedByName } from '../selectors/babies';

function BabyCreateModal(props) {
  const { babies } = props;

  return (
    <Modal isOpen={props.isOpen} onRequestClose={props.onRequestClose}>
      {!babies.length && <h5>Add your baby to start tracking.</h5>}

      <BabyCreateContainer
        onRequestClose={props.onRequestClose}
        onBabyCreated={props.onBabyCreated}
        onCancelClicked={props.onRequestClose}
      />
    </Modal>
  );
}

BabyCreateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onBabyCreated: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    babies: getBabiesSortedByName(state)
  };
}

export default connect(mapStateToProps, null)(BabyCreateModal);
